import { IApplicationState } from '../../types/redux';

export const selectNearbyHousesInfo = (state: IApplicationState) => state.nearbyHousesInfo;
